<ng-container *transloco="let t">
	<div class="mt-2 px-4">
		@if (partners && partners.length > 6) {
			<div #swiperContainer class="swiper">
				<div class="swiper-wrapper">
					@for (partner of partners; track partner.id) {
						<div class="swiper-slide">
							<a
								class="partner flex h-logos items-center justify-center opacity-50 transition-all duration-200 ease-in-out hover:opacity-100"
								routerLink="/conference/{{ conf }}/partner/{{ partner.id }}/{{ page }}/{{ partner.name | slugify }}"
								[title]="t('UI.visit_sponsors_label') + partner.name"
							>
								<img class="h-full w-full object-center" [src]="partner.logo?.url" [alt]="partner.name" onerror="this.src = './assets/images/placeholder/et-fallback_logo.png'" />
							</a>
						</div>
					}
				</div>
			</div>
		} @else {
			<div class="flex flex-row flex-wrap items-center justify-center">
				@for (partner of partners; track partner.id) {
					<div class="w-1/3 px-2 md:w-1/6 md:px-4">
						<a
							class="block opacity-50 transition-all duration-200 ease-in-out hover:opacity-100"
							routerLink="/conference/{{ conf }}/partner/{{ partner.id }}/{{ page }}/{{ partner.name | slugify }}"
							[title]="t('UI.visit_sponsors_label') + partner.name"
						>
							<img class="mx-auto block h-auto w-full" [src]="partner.logo?.url" [alt]="partner.name" onerror="this.src = './assets/images/placeholder/et-fallback_logo.png'" />
						</a>
					</div>
				}
			</div>
		}
	</div>
</ng-container>
